import { render } from "./PageHome.vue?vue&type=template&id=05961770&scoped=true&ts=true"
import script from "./PageHome.vue?vue&type=script&lang=ts"
export * from "./PageHome.vue?vue&type=script&lang=ts"

import "./PageHome.vue?vue&type=style&index=0&id=05961770&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05961770"]])

export default __exports__